import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import Header from '@/components/generals/header'
import Footer from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='relative flex min-h-screen flex-col overflow-x-clip'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:top-4 focus:right-4 focus:z-[60] focus:rounded-xl focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-primary focus:shadow-lifted'
            >
                پرش به محتوای اصلی
            </a>

            <Header />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
